import {
  HelpLinesSystem,
  FunctionalMarginCollisionSystem,
  PlannerCoreApi,
  HelpLinesOuterMeasurementSystem,
  HelpLinesColliderBoxSystem
} from '@inter-ikea-storageone/range';
import { Feature } from '../../../../features/Feature';
import { DisableFrameDistanceMeasurementSystem } from '@inter-ikea-storageone/range-platsa';

export class HelpLinesFeature extends Feature {
  protected init(coreApi: PlannerCoreApi): void {
    coreApi.registerSystem(new FunctionalMarginCollisionSystem(coreApi));
    const helpLinesSystem = new HelpLinesSystem(coreApi);
    coreApi.registerSystem(helpLinesSystem);
    helpLinesSystem.init();
    coreApi.registerSystem(new HelpLinesOuterMeasurementSystem(coreApi));
    coreApi.registerSystem(new DisableFrameDistanceMeasurementSystem(coreApi));
    coreApi.registerSystem(new HelpLinesColliderBoxSystem(coreApi));
  }
}
